import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { useTheme, useMediaQuery } from "@mui/material";
import RenotenLogo from "../images/renoten_logo_horizontal.svg";
import { trackEvent } from "../utils/analytics";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { colors } from "../theme/tokens";

const Navbar: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  const handleSignUpClick = () => {
    trackEvent("redirect_to_app", {
      location: "navbar",
      destination: "app",
    });
  };

  const handleLogoClick = () => {
    if (isHomePage) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const linkSx = {
    color: colors.ink,
    textTransform: "none" as const,
    fontWeight: 500,
    fontSize: { xs: "14px", sm: "15px" },
    px: { xs: 1, sm: 1.75 },
    py: 1,
    minWidth: 0,
    whiteSpace: "nowrap" as const,
    borderRadius: "8px",
    "&:hover": { background: colors.primaryTint, color: colors.primary },
  };

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        background: "rgba(255, 255, 255, 0.85)",
        backdropFilter: "blur(20px)",
        borderBottom: `1px solid ${colors.border}`,
      }}
    >
      <Toolbar disableGutters sx={{ py: 1, px: { xs: 2, md: 6 }, gap: 1 }}>
        <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
          <RouterLink to="/" style={{ display: "inline-flex" }}>
            <img
              src={RenotenLogo}
              alt="Renoten Logo"
              onClick={handleLogoClick}
              style={{
                height: isMobile ? "22px" : "26px",
                cursor: "pointer",
              }}
            />
          </RouterLink>
        </Box>

        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          {isHomePage && (
            <Button
              color="inherit"
              onClick={() => scrollToSection("features")}
              sx={linkSx}
            >
              Features
            </Button>
          )}

          <Button color="inherit" component={RouterLink} to="/blog" sx={linkSx}>
            Blog
          </Button>

          <Button
            variant="contained"
            disableElevation
            href="https://app.renoten.com/signup"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleSignUpClick}
            sx={{
              ml: { xs: 0.5, sm: 1 },
              background: colors.primary,
              textTransform: "none",
              whiteSpace: "nowrap",
              px: { xs: 1.75, sm: 2.5 },
              py: { xs: 1, sm: 1.25 },
              fontWeight: 600,
              fontSize: { xs: "14px", sm: "15px" },
              borderRadius: "10px",
              "&:hover": { background: colors.primaryHover },
            }}
          >
            Get Started
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
